import AuthService from '../../services/authService';
import UserService from '../user/services/userService';
import LoginController from './loginController';

import _ from './login.scss';

const Login = {
    template: require('./loginView.html'),
    controller: LoginController
};

export default angular.module('app.login', [])
    .component('login', Login)
    .service("AuthService", AuthService)
    .service("UserService", UserService)
    .name;



// WEBPACK FOOTER //
// ./src/app/pages/login/loginComponent.js